import { combineReducers } from '@reduxjs/toolkit';
import mainReducer from 'reducers/main';
import { configReducer } from 'reducers/config';
import { workflowsSlice } from 'reducers/workflows';
import { answersSlice } from 'reducers/answers';
import liveChatReducer from './live-chat';

const rootReducer = combineReducers({
  answers: answersSlice.reducer,
  config: configReducer,
  liveChat: liveChatReducer,
  main: mainReducer,
  workflows: workflowsSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
